import React, {useState, useEffect} from 'react';
import { useParams } from 'react-router-dom';
import DetailSingle from './DetailSingle';

const ProjectDetails = () => {
     const {detailId} = useParams();

     const [projects, setProjects] = useState([])
     console.log(projects);

     useEffect(()=>{
          fetch('/projectdata.json')
          .then(res => res.json())
          .then(data => setProjects(data.filter( del => del.id == detailId)))
     },[])

     

     return (
          <section className="pb-10">
          <div className="flex flex-wrap md:px-4">
            {projects.map(detail =><DetailSingle 
            detail={detail}
            key={detail.id} /> )}
          </div>
        </section>
     );
};

export default ProjectDetails;